import {store_var, store_getStateValue_vo, store_setStateValue} from './store'

import Vue from 'vue'
import Router from 'vue-router'
import {
    enum_routeScrollableMode_e,
    enum_subDomains
} from "../functions/src/shareCode/Share_S_Enum";
import {
    enum_questEventStatus,
    enum_langCodes,
    enum_moveToOptions,
    enum_urlParams
} from "../functions/src/shareCode/Share_S_Enum";
import {seo_updateMeta_f} from "./scripts/S_seo";
import {gv_strings, gv_urls} from "./scripts/S_GlobalVar";
import {obj_deepCopy_f} from "../functions/src/shareCode/Share_S_Obj";
import {Cla_ViewRouteMetadata} from "./classes/TqClasses";
import {date_setTimeout} from "./scripts/S_Date";

Vue.use(Router)

const routeName_s = 'route'

const routeViewMetaData_byPath_c = {

    // ==== player ====
    // player explore
    [enum_moveToOptions.player_store]    : new Cla_ViewRouteMetadata({

        vrm_scrollMode_e    : enum_routeScrollableMode_e.topToBottom
    }),
    [enum_moveToOptions.player_store_quest]    : new Cla_ViewRouteMetadata({
        vrm_showBackBtn_b   : true,
        vrm_scrollMode_e    : enum_routeScrollableMode_e.topToBottom
    }),
    [enum_moveToOptions.player_store_whiteLabel]    : new Cla_ViewRouteMetadata({
        vrm_showBackBtn_b   : false,
        vrm_scrollMode_e    : enum_routeScrollableMode_e.topToBottom,
        vrm_hideTopBar_b    : true,
        vrm_hideBottomBar_b : true,
    }),
    [enum_moveToOptions.player_store_agent]    : new Cla_ViewRouteMetadata({
        vrm_showBackBtn_b   : false,
        vrm_scrollMode_e    : enum_routeScrollableMode_e.topToBottom,
        vrm_hideTopBar_b    : true,
        vrm_hideBottomBar_b : true,
    }),
    [enum_moveToOptions.player_store_creator]  : new Cla_ViewRouteMetadata({
        vrm_showBackBtn_b   : true,
        vrm_scrollMode_e    : enum_routeScrollableMode_e.topToBottom
    }),
    [enum_moveToOptions.player_store_category]  : new Cla_ViewRouteMetadata({
        vrm_showBackBtn_b   : true,
        vrm_scrollMode_e    : enum_routeScrollableMode_e.topToBottom
    }),

    // player tickets
    [enum_moveToOptions.player_play_list]    : new Cla_ViewRouteMetadata({}),
    [enum_moveToOptions.player_play_entry_ticket]    : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : null,
        vrm_showBackBtn_b   : false,
        vrm_hideBottomBar_b : true,
        vrm_hideTopBar_b    : true,
        vrm_scrollMode_e    : enum_routeScrollableMode_e.topToBottom
    }),

    // profile
    [enum_moveToOptions.player_profile]         : new Cla_ViewRouteMetadata({}),

    // ==== creator ====
    // event
    [enum_moveToOptions.creator_events_list]         : new Cla_ViewRouteMetadata({}),
    [enum_moveToOptions.creator_events_item]         : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.creator_events_list,
        vrm_showBackBtn_b   : true,
    }),

    // edit
    [enum_moveToOptions.creator_edit_list]         : new Cla_ViewRouteMetadata({}),
    [enum_moveToOptions.creator_edit_item]         : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.creator_edit_list,
        vrm_showBackBtn_b   : true,
    }),
    [enum_moveToOptions.creator_edit_create]         : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.creator_edit_list,
        vrm_showBackBtn_b   : true,
    }),

    // profile
    [enum_moveToOptions.creator_profile]         : new Cla_ViewRouteMetadata({}),

    // ==== ongoing ====
    // status
    [enum_moveToOptions.ongoing_status]                     : new Cla_ViewRouteMetadata({}),
    // chat
    [enum_moveToOptions.ongoing_chat]                       : new Cla_ViewRouteMetadata({
        vrm_scrollMode_e    : enum_routeScrollableMode_e.bottomToTop
    }),
    // camera
    [enum_moveToOptions.ongoing_camera]                     : new Cla_ViewRouteMetadata({
        vrm_showBackBtn_b   : true,
        vrm_hideTopBar_b    : true,
        vrm_hideBottomBar_b : true,
    }),
    // questRules
    [enum_moveToOptions.ongoing_questRules]                 : new Cla_ViewRouteMetadata({}),
    // cards
    [enum_moveToOptions.ongoing_quest_cards]                : new Cla_ViewRouteMetadata({}),
    // mission list
    [enum_moveToOptions.ongoing_Missions_List]              : new Cla_ViewRouteMetadata({}),
    [enum_moveToOptions.ongoing_Missions_Item]              : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.ongoing_Missions_List,
        vrm_showBackBtn_b   : true,
    }),
    [enum_moveToOptions.ongoing_Missions_Last]              : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.ongoing_Missions_List,
        vrm_showBackBtn_b   : true,
    }),
    // open map
    [enum_moveToOptions.ongoing_quest_openMap_map]          : new Cla_ViewRouteMetadata({
        vrm_scrollMode_e    : enum_routeScrollableMode_e.noScrolling

    }),
    [enum_moveToOptions.ongoing_quest_openMap_riddle]  : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.ongoing_quest_openMap_map,
        vrm_showBackBtn_b   : true,
    }),
    [enum_moveToOptions.ongoing_quest_openMap_lastRiddles]  : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.ongoing_quest_openMap_map,
        vrm_showBackBtn_b   : true,
    }),

    [enum_moveToOptions.ongoing_quest_openMapPolygons_missions]  : new Cla_ViewRouteMetadata({
    }),
    [enum_moveToOptions.ongoing_quest_openMapPolygons_riddle]  : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.ongoing_quest_openMapPolygons_missions,
        vrm_showBackBtn_b   : true,
    }),


    // === terms ===
    [enum_moveToOptions.terms]             : new Cla_ViewRouteMetadata({
        vrm_showBackBtn_b   : true,
        vrm_hideBottomBar_b : true,
    }),


    // === standAlong ===
    [enum_moveToOptions.standAlong_welcome]             : new Cla_ViewRouteMetadata({
        vrm_hideTopBar_b    : true,
        vrm_hideBottomBar_b : true,
    }),
    [enum_moveToOptions.standAlong_questMedia]             : new Cla_ViewRouteMetadata({
        vrm_hideTopBar_b    : true,
        vrm_hideBottomBar_b : true,
    }),
    [enum_moveToOptions.standAlong_about]               : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.root,
        vrm_showBackBtn_b   : true,
        vrm_hideBottomBar_b : true,
    }),
    [enum_moveToOptions.standAlong_pricing]               : new Cla_ViewRouteMetadata({
        vrm_backTo_s        : enum_moveToOptions.root,
        vrm_showBackBtn_b   : true,
        vrm_hideBottomBar_b : true,
    }),
    [enum_moveToOptions.standAlong_paymentSuccess]      : new Cla_ViewRouteMetadata({
        vrm_hideBottomBar_b : true,
        vrm_hideTopBar_b : true,
    }),
    [enum_moveToOptions.standAlong_iframeSuccessMsg]    : new Cla_ViewRouteMetadata({
        vrm_hideBottomBar_b : true,
        vrm_hideTopBar_b : true,
    }),
    [enum_moveToOptions.standAlong_iframeFailedMsg]     : new Cla_ViewRouteMetadata({
        vrm_hideBottomBar_b : true,
        vrm_hideTopBar_b : true,
    }),
    [enum_moveToOptions.standAlong_paymentFailed]       : new Cla_ViewRouteMetadata({
        vrm_hideBottomBar_b : true,
        vrm_hideTopBar_b : true,
    }),
}

const router = new Router({
    mode: 'history',
    routes:  [
        {
            path: '/:lang',
            component: () => import('./views/v_langCode'),
            children: [

                // 1) player
                {
                    path: '/',
                    component: () => import('./views/v_Player'),
                    children: [

                        // 1.2) play
                        {
                            path: "/:lang" + enum_moveToOptions.player_play,
                            component: () => import('./views/v_player/v_Player_play'),
                            redirect: "/:lang" + enum_moveToOptions.player_play_list,
                            children:[
                                {
                                    path: "/:lang" + enum_moveToOptions.player_play_list,
                                    component: () => import('./views/v_player/v_Player_Play/v_Player_Play_List'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_play_list]

                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.player_play_entry_ticket,
                                    component: () => import('./views/v_player/v_Player_Play/v_Player_Play_Item'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_play_entry_ticket]
                                },

                                // todo - remove support old version:
                                {
                                    path: "/:lang/player-tickets-list",
                                    redirect : "/:lang" + enum_moveToOptions.player_play_list
                                },
                                {
                                    path: "/:lang/player-tickets-item",
                                    redirect : "/:lang" + enum_moveToOptions.player_play_entry_ticket
                                },
                            ]
                        },

                        // 1.1) Store
                        {
                            path:  "/:lang" + enum_moveToOptions.player_store,
                            component: () => import('./views/v_player/v_Player_Store'),
                            children:[
                                {
                                    path: '/:lang' + enum_moveToOptions.player_store,
                                    component: () => import('./views/v_player/v_player_store/v_Player_Store_Main'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_store]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.player_store_quest + "/:questId",
                                    component: () => import('./views/v_player/v_player_store/v_Player_Store_Quest'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_store_quest],
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.player_store_creator + "/:creatorId",
                                    component: () => import('./views/v_player/v_player_store/v_Player_Store_Creator'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_store_creator]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.player_store_category + "/:category",
                                    component: () => import('./views/v_player/v_player_store/v_Player_Store_Category'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_store_category]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.player_store_category + "/:category/:questId",
                                    component: () => import('./views/v_player/v_player_store/v_Player_Store_Quest'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_store_quest]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.player_store_whiteLabel,
                                    component: () => import('./views/v_player/v_player_store/v_Player_Store_WhiteLabel'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_store_whiteLabel]
                                },

                                // todo - remove support old version:
                                {
                                    path: "/:lang/player-explore-quest/:questId",
                                    redirect : "/:lang" + enum_moveToOptions.player_store_quest + "/:questId"
                                },
                                {
                                    path: "/:lang/player-explore-quest",
                                    redirect:(to) => {
                                        return "/:lang" + enum_moveToOptions.player_store_quest + "/" + to.query.questId
                                    }
                                },
                                {
                                    path: "/:lang/player-explore-whitelabel",
                                    redirect : "/:lang" + enum_moveToOptions.player_store_whiteLabel,
                                },
                                {
                                    path: "/:lang/player-explore-agent",
                                    redirect:(to) => {
                                        return "/:lang" + enum_moveToOptions.player_store_quest + "/" + to.query.questId
                                    }
                                },
                                {
                                    path: "/:lang/player-explore-list",
                                    redirect : "/:lang" + enum_moveToOptions.player_store
                                },
                                {
                                    path: "/:lang/player-explore",
                                    redirect : "/:lang" + enum_moveToOptions.player_store
                                },
                                {
                                    path: "/:lang/player-profile",
                                    redirect : "/:lang" + enum_moveToOptions.player_profile
                                }
                            ]
                        },

                        // 1.2) Profile
                        {
                            path: "/:lang" + enum_moveToOptions.player_profile,
                            component: () => import('./views/v_player/v_Player_Profile'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.player_profile]

                        },



                    ]
                },

                // 2) creator
                {
                    path: "/:lang" + enum_moveToOptions.creator,
                    component: () => import('./views/v_Creator'),
                    redirect: "/:lang" + enum_moveToOptions.creator_edit,
                    children: [

                        // 2.1) editQuests
                        {
                            path: "/:lang" + enum_moveToOptions.creator_edit,
                            component: () => import('./views/v_Creator/v_Creator_EditQuests'),
                            redirect: "/:lang" + enum_moveToOptions.creator_edit_list,
                            children: [
                                {
                                    path: "/:lang" + enum_moveToOptions.creator_edit_list,
                                    component: () => import('./views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuests_List'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.creator_edit_list]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.creator_edit_item,
                                    component: () => import('./views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuests_Item'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.creator_edit_item]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.creator_edit_create,
                                    component: () => import('./views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuests_Create'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.creator_edit_create]
                                },
                            ]
                        },

                        // 2.2) events
                        {
                            path: "/:lang" + enum_moveToOptions.creator_events,
                            component: () => import('./views/v_Creator/v_Creator_Events'),
                            redirect: "/:lang" + enum_moveToOptions.creator_events_list,
                            children: [
                                {
                                    path: "/:lang" + enum_moveToOptions.creator_events_list,
                                    component: () => import('./views/v_Creator/v_Creator_Events/V_Creator_Events_List'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.creator_events_list]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.creator_events_item,
                                    component: () => import('./views/v_Creator/v_Creator_Events/V_Creator_Events_Item'),
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.creator_events_item]
                                }
                            ]
                        },

                        // 2.3) profile
                        {
                            path: "/:lang" + enum_moveToOptions.creator_profile,
                            component: () => import('./views/v_Creator/v_Creator_Profile'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.creator_profile]
                        },

                    ]
                },

                // 3) ongoing
                {
                    path: "/:lang" + enum_moveToOptions.ongoing,
                    component: () => import('./views/v_Ongoing'),
                    redirect: "/:lang" +  enum_moveToOptions.ongoing_status,
                    children: [
                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_status,
                            component: () => import('./views/v_Ongoing/v_Ongoing_Status'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_status]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_chat,
                            component: () => import('./views/v_Ongoing/v_Ongoing_Chat'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_chat]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_camera,
                            component: () => import('./views/v_Ongoing/v_Ongoing_Camera'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_camera]
                        },

                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_questRules,
                            component: () => import('./views/v_Ongoing/V_Ongoing_QuestRules'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_questRules]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_Missions,
                            component: () => import('./views/v_Ongoing/v_Ongoing_Missions'),
                            redirect: to => {

                                if(route_currentPath2_s().includes(enum_moveToOptions.ongoing_Missions)){
                                    return  route_addLangToPath_s(enum_moveToOptions.ongoing_Missions_List)
                                }else{
                                    let newTo = obj_deepCopy_f(store_getStateValue_vo(store_var.lastRoute_ongoing_missions).val)

                                    if(newTo.fullPath != null){newTo.fullPath = route_addLangToPath_s(newTo.fullPath)}
                                    newTo.path = route_addLangToPath_s(newTo.path)

                                    return  newTo
                                }

                            },
                            children:[
                                {
                                    path: "/:lang" + enum_moveToOptions.ongoing_Missions_List,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_Missions/v_Ongoing_Missions_List'),
                                    beforeEnter: (to, from, next) => {

                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }

                                        store_setStateValue(store_var.lastRoute_ongoing_missions, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_Missions_List]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.ongoing_Missions_Item,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_Missions/v_Ongoing_Missions_Item'),
                                    beforeEnter: (to, from, next) => {
                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }

                                        store_setStateValue(store_var.lastRoute_ongoing_missions, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_Missions_Item]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.ongoing_Missions_Last,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_Missions/V_Ongoing_Missions_Last'),
                                    beforeEnter: (to, from, next) => {
                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }

                                        store_setStateValue(store_var.lastRoute_ongoing_missions, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_Missions_Last]
                                },
                            ]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_quest_cards,
                            component: () => import('./views/v_Ongoing/v_Ongoing_Cards'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_quest_cards]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_quest_openMap,
                            component:  () => import('./views/v_Ongoing/v_Ongoing_OpenMap'),
                            redirect:   (to) => {

                                if(route_currentPath2_s().includes(enum_moveToOptions.ongoing_quest_openMap)){
                                    return route_addLangToPath_s(enum_moveToOptions.ongoing_quest_openMap_map)
                                }else{

                                    let newTo = obj_deepCopy_f(store_getStateValue_vo(store_var.lastRoute_ongoing_openMap_map).val)

                                    if(newTo.fullPath != null){newTo.fullPath = route_addLangToPath_s(newTo.fullPath)}
                                    newTo.path = route_addLangToPath_s(newTo.path)

                                    return newTo
                                }

                            },
                            children: [
                                {
                                    path : "/:lang" + enum_moveToOptions.ongoing_quest_openMap_map,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_Map/v_Ongoing_OpenMap_Map'),
                                    beforeEnter: (to, from, next) => {

                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }

                                        store_setStateValue(store_var.lastRoute_ongoing_openMap_map, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_quest_openMap_map]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.ongoing_quest_openMap_riddle,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_Map/V_Ongoing_OpenMap_Riddle'),
                                    beforeEnter: (to, from, next) => {


                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }

                                        store_setStateValue(store_var.lastRoute_ongoing_openMap_map, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_quest_openMap_riddle]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.ongoing_quest_openMap_lastRiddles,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_Map/V_Ongoing_OpenMap_LastRiddles'),
                                    beforeEnter: (to, from, next) => {
                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }
                                        store_setStateValue(store_var.lastRoute_ongoing_openMap_map, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_quest_openMap_lastRiddles]
                                }
                            ]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.ongoing_quest_openMapPolygons,
                            component:  () => import('./views/v_Ongoing/v_Ongoing_PolygonsMap'),
                            redirect:   (to) => {
                                if(route_currentPath2_s().includes(enum_moveToOptions.ongoing_quest_openMapPolygons)){
                                    return route_addLangToPath_s(enum_moveToOptions.ongoing_quest_openMapPolygons_missions)
                                }else{

                                    let newTo = obj_deepCopy_f(store_getStateValue_vo(store_var.lastRoute_ongoing_polygonMap).val)

                                    if(newTo.fullPath != null){newTo.fullPath = route_addLangToPath_s(newTo.fullPath)}
                                    newTo.path = route_addLangToPath_s(newTo.path)

                                    return newTo
                                }
                            },
                            children: [
                                {
                                    path : "/:lang" + enum_moveToOptions.ongoing_quest_openMapPolygons_missions,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_PolygonsMap/V_Ongoing_PolygonsMap_List'),
                                    beforeEnter: (to, from, next) => {

                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }

                                        store_setStateValue(store_var.lastRoute_ongoing_polygonMap, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_quest_openMapPolygons_missions]
                                },
                                {
                                    path: "/:lang" + enum_moveToOptions.ongoing_quest_openMapPolygons_riddle,
                                    component: () => import('./views/v_Ongoing/v_Ongoing_PolygonsMap/V_Ongoing_PolygonMap_Riddle'),
                                    beforeEnter: (to, from, next) => {

                                        let newTo = {
                                            fullPath : to.fullPath.substring(3),
                                            path : to.path.substring(3),
                                            query : to.query
                                        }

                                        store_setStateValue(store_var.lastRoute_ongoing_polygonMap, newTo)
                                        next()
                                    },
                                    meta : routeViewMetaData_byPath_c[enum_moveToOptions.ongoing_quest_openMapPolygons_riddle]
                                },
                            ]
                        },
                    ]
                },

                // 4) admin
                {
                    path: "/:lang" + enum_moveToOptions.admin,
                    component: () => import('./views/v_Admin'),
                    redirect: "/:lang" + enum_moveToOptions.admin_quests,
                    children: [
                        {
                            path: "/:lang" + enum_moveToOptions.admin_quests,
                            component: () => import('./views/v_admin/v_Admin_Manage_Quests'),
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.admin_users,
                            component: () => import('./views/v_admin/v_Admin_Manage_Players'),
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.admin_events,
                            component: () => import('./views/v_admin/v_Admin_Manage_Events'),
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.admin_tickets,
                            component: () => import('./views/v_admin/v_Admin_Manage_Tickets'),
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.admin_blog,
                            component: () => import('./views/v_admin/v_Admin_Blogs'),
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.admin_reviewsReports,
                            component: () => import('./views/v_admin/v_Admin_Actions'),
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.admin_discountCoupons,
                            component: () => import('./views/v_admin/v_Admin_DiscountCoupons'),
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.admin_errors,
                            component: () => import('./views/v_admin/v_Admin_Errors'),
                        },

                    ]},

                // 5) terms
                {
                    path: "/:lang" + enum_moveToOptions.terms,
                    component: () => import('./views/v_Terms'),
                    redirect: "/:lang" +  enum_moveToOptions.terms_termsOfUse,
                    children: [
                        {
                            path: "/:lang" + enum_moveToOptions.terms_termsOfUse,
                            component: () => import('./views/v_Terms/v_Terms_TermsOfUse'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.terms]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.terms_privacyPolicy,
                            component: () => import('./views/v_Terms/v_Terms_PrivacyPolicy'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.terms]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.terms_disclaimer,
                            component: () => import('./views/v_Terms/v_Terms_Disclaimer'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.terms]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.terms_cookiePolicy,
                            component: () => import('./views/v_Terms/v_Terms_CookiePolicy'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.terms]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.terms_creatorPolicy,
                            component: () => import('./views/v_Terms/v_Terms_CreatorPolicy'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.terms]
                        },
                    ]
                },

                // 6) stand alone
                {
                    path: '/',
                    component: () => import('./views/v_StandAlone'),
                    children: [
                        {
                            path: "/:lang" + enum_moveToOptions.standAlong_welcome,
                            component: () => import('./views/v_standAlone/v_Welcome'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.standAlong_welcome]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.standAlong_questMedia + "/:ticketId",
                            component: () => import('./views/v_standAlone/v_QuestMedia'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.standAlong_questMedia]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.standAlong_about,
                            component: () => import('./views/v_standAlone/v_About'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.standAlong_about]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.standAlong_pricing,
                            component: () => import('./components/basic/TqPricing'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.standAlong_pricing]
                        },

                        {
                            path: "/:lang" + enum_moveToOptions.standAlong_iframeSuccessMsg,
                            component: () => import('./views/v_standAlone/v_IframeSuccessMsg'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.standAlong_iframeSuccessMsg]
                        },
                        {
                            path: "/:lang" + enum_moveToOptions.standAlong_iframeFailedMsg,
                            component: () => import('./views/v_standAlone/v_IframeFailedMsg'),
                            meta : routeViewMetaData_byPath_c[enum_moveToOptions.standAlong_iframeFailedMsg]
                        },
                        {
                            path: 'emailBoughtTicket',
                            component: () => import('./views/v_standAlone/v_EmailBoughtTicket'),
                        },
                        {
                            path: 'emailCancelTicket',
                            component: () => import('./views/v_standAlone/v_EmailCancelTicket'),
                        },
                        {
                            path: 'monthSummary',
                            component: () => import('./views/v_standAlone/v_EmailCreatorMonthSummary'),
                        },
                        {
                            path: 'emailFinishQuest',
                            component: () => import('./views/v_standAlone/v_EmailFinishQuest'),
                        },
                        {
                            path: 'emailQuestEventEnd',
                            component: () => import('./views/v_standAlone/v_Email_QuestEventEndSummary'),
                        },
                        {
                            path: 'emailReview',
                            component: () => import('./views/v_standAlone/v_Email_Review'),
                        },

                    ]},

                // 7) redirect
                {
                    // will match everything
                    path: '*',
                    redirect: "/:lang",
                }
            ]
        },
    ],
})

// first to load in app
router.beforeEach((to, from, next) => {

    // checkLangCode
    let fullPath_s = to.fullPath

    let fullPath_split_as = fullPath_s.split("/")

    let path_langCode_e = fullPath_split_as[1]
    let store_langCode_e = store_getStateValue_vo(store_var.system_langCode).val

    // path dont have lang
    if(!Object.values(enum_langCodes).includes(path_langCode_e)){
        fullPath_split_as[1] = store_langCode_e
        const newPath_s = fullPath_split_as.join("/")
        next(newPath_s)
        return
    }

    // update store
    if(path_langCode_e !== store_langCode_e){
        store_setStateValue(store_var.system_langCode, path_langCode_e)
    }

    // update ScrollMode
    beforeEach_updateScrollMode_f(to.meta.vrm_scrollMode_e)

    // next
    seo_updateMeta_f({path_s: fullPath_s, langCode_es :path_langCode_e})
    next()

})
const beforeEach_updateScrollMode_f = (scrollMode_e) => {

    let html = document.documentElement;
    let body = document.body;

    // scroll to top
    switch(scrollMode_e){

        case enum_routeScrollableMode_e.bottomToTop:
            html.style.overflow = 'auto'
            body.style.overflow = 'auto'
            body.style.position = 'initial'
            date_setTimeout(() => {
                route_scrollToBottom_f()
            },1, routeName_s)
            break;

        case enum_routeScrollableMode_e.topToBottom:
            html.style.overflow = 'auto'
            body.style.overflow = 'auto'
            body.style.position = 'initial'
            date_setTimeout(() => {
                route_scrollToTop_f()
            },1, routeName_s)
            break;

        case enum_routeScrollableMode_e.noScrolling:
            body.style.position = 'fixed'
            body.style.overflow = 'hidden'
            html.style.overflow = 'hidden'
    }
}
router.beforeResolve((to, from, next) => {

    // 1) ongoing
    if(to.fullPath.includes(enum_moveToOptions.ongoing)) {

        // 1.1) quest event
        let ongoingQuestEvent = store_getStateValue_vo(store_var.ongoing_questEvent).val
        if (!ongoingQuestEvent) {
            next(route_addLangToPath_s(enum_moveToOptions.player_play_list))
            return
        }

        // 1.2) ongoing-missions/ ongoing-quest
        if (to.fullPath.includes(enum_moveToOptions.ongoing_Missions) ||
            to.fullPath.includes(enum_moveToOptions.ongoing_quest_openMap) ||
            to.fullPath.includes(enum_moveToOptions.ongoing_quest_cards)){

            let ongoing_currentTeamId_uid = store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val
            let clockStatus = store_getStateValue_vo(store_var.ongoing_eventCurrentStatus).val

            // teamId && clockStatus == ongoing
            if (!ongoing_currentTeamId_uid || clockStatus !== enum_questEventStatus.ongoing) {
                next(route_addLangToPath_s(enum_moveToOptions.ongoing_status))
                return
            }

            // 1.1.1) ongoing_missions_item
            if (to.fullPath.includes(enum_moveToOptions.ongoing_Missions_Item)) {

                let missionId_n = route_getUrlParams(to, enum_urlParams.missionRiddleId_n)

                if (missionId_n == null) {
                    next(route_addLangToPath_s(enum_moveToOptions.ongoing_Missions_List))
                    return
                }
            }

            // 1.1.2) ongoing_quest_openMap_riddle
            if (to.fullPath.includes(enum_moveToOptions.ongoing_quest_openMap_riddle)) {
                // route
                let riddleId_n = route_getUrlParams(to, enum_urlParams.riddleId_n)

                if (riddleId_n == null) {
                    next(route_addLangToPath_s(enum_moveToOptions.ongoing_quest_openMap_map))
                    return
                }
            }

            // 1.1.3) ongoing_quest_openMap_riddle
            if (to.fullPath.includes(enum_moveToOptions.ongoing_quest_openMapPolygons)) {
                // route
                let groupId_n = route_getUrlParams(to, enum_urlParams.groupId_n)

                if (groupId_n == null) {
                    next(route_addLangToPath_s(enum_moveToOptions.ongoing_quest_openMap_map))
                    return
                }
            }
        }

        // 1.3) ongoing chat
        if (to.fullPath.includes(enum_moveToOptions.ongoing_chat)) {

            let store_currentTeamId_uid = store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val

            if (store_currentTeamId_uid == null) {
                next(route_addLangToPath_s(enum_moveToOptions.ongoing_status))
                return
            }
        }
    }

    next()

})

// route_getRouteMeta_fo
export const route_getRouteMeta_fo = ($route) => {

    if($route){
        return $route.meta
    }else{
        return new Cla_ViewRouteMetadata({})
    }

}

// route_scrollToBottom_f
export const route_scrollToBottom_f = () => {


    let html = document.documentElement;
    let body = document.body;

    let pageHeight_n = Math.max( body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight );

    html.scrollTop = pageHeight_n

}

// route_scrollToTop_f
export const route_scrollToTop_f = () => {
    let html = document.documentElement;
    html.scrollTop = 0
}

// route_switchLangCode_es
export const route_switchLangCode_es = (route_o, langCode_es) => {
    let fullPath_s = window.location.pathname + window.location.search
    return "/" + langCode_es + fullPath_s.substring(3)
}

// route_addLangToPath_s
export const route_addLangToPath_s = (path_s) => {

    return '/' + store_getStateValue_vo(store_var.system_langCode).val + path_s
}

// route_moveToRoute
export const route_moveToRoute = (path, query) => {

    router.push({ path: route_addLangToPath_s(path), query: query})

}

// route_replace
export const route_replace = (path, query) => {
    router.replace({ path: route_addLangToPath_s(path), query: query})
}

// route_currentPath_s
export const route_currentPath_s = (route) => {
    return route.path
}
export const route_currentPath2_s = () => {
    return window.location.href
}


// route_moveToRoute_withData
export const route_moveToRoute_withData_f = (path, data) => {
    router.push({ path: route_addLangToPath_s(path), query: {data : JSON.stringify(data)}})
}

// route_getCurrentFullPath_s
export const route_getCurrentFullPath_s = () => {
    return window.location.href
}

// route_getUrlParams
export const route_getUrlData_fo = (route) => {
    if(route.query.data == null){return null}

    return JSON.parse(route.query.data)
}

// route_getUrlParams
export const route_getUrlParams = (route , paramName) => {
    return route.query[paramName]
}

// route_urlLastPath
export const route_urlLastPath_fs = () => {
    let path_as = route_getCurrentFullPath_s().split("?")[0].split('/')
    return path_as[path_as.length - 1]
}

// route_back
export const route_back = () =>{
    router.go(-1)
}

// route_refreshPage_forces
export const route_refreshPage_force = () => {
    location.reload(true);
}

// refreshPage
export const route_refreshPage = () => {
    location.reload();
}

// route_windowReplace_f
export const route_windowReplace_f = (url_s) => {
    window.location.replace(url_s)
}

// route_openNewWindow_f
export const route_openNewWindow_f = (url_s, name_s, width_s='height=400,width=300') => {
    window.open(url_s, name_s);
}

// route_openNewTab_f
export const route_openNewTab_f = (langCode_e, url_s, query_os) => {

    let fullUrl_s = `/${langCode_e}${url_s}`
    if(query_os){
        fullUrl_s += "?"
        for(let key in query_os){
            fullUrl_s += key + '=' + query_os[key]
        }
    }

    window.open(fullUrl_s, '_blank');
}

// route_moveToWindow_f
export const route_moveToWindow_f = (url_s) => {
    window.location.href =  url_s

}

// route_moveToChrome_f
export const route_moveToChrome_f = () => {

    let currentFullUrl = window.location.href
    let chromeUrl = gv_urls.chrome_prefix + currentFullUrl


    route_openNewWindow_f(chromeUrl, "chrome")
}

// route_getCurrentSubDomain_s
export const route_getCurrentSubDomain_s = () => {
    const host = window.location.host
    const domainSplit_as = host.split('.')
    return domainSplit_as[0]
}

// route_moveToSubDomain_f
export const route_moveToSubDomain_f = (subDomain_e) => {
    window.location = `https://${subDomain_e}.${gv_strings.domain}${window.location.pathname}${window.location.search}`
}

// export
export default router;
